export default __webpack_public_path__ + "static/media/prefooter.10be3598.svg";